module.exports = __webpack_public_path__ + "img/xiaolin-xiaochengxu.5b11452e.jpg";